import type { SessionDownloadOption } from '@frontend/core/lib/domains/sessions/download-definitions'
import {
  SESSION_DOWNLOAD_DEFINITIONS,
  SESSION_DOWNLOAD_OPTIONS,
  sortByDisplayPreference
} from '@frontend/core/lib/domains/sessions/download-definitions'

// Checkbox labels for Match Tracker's download types. Not part of
// SESSION_DOWNLOAD_DEFINITIONS — that module only carries endpoint/accept-
// header/unit/app metadata, not display copy — mirroring the precedent in
// apps/ui/reporting/src/lib/use-session-export.ts's own EXPORT_LABELS map.
// MT and Reporting intentionally keep separate label text.
//
// Lives in its own module (rather than alongside DownloadForm in
// components.tsx) so exporting it doesn't mix component and non-component
// exports in a file react-refresh needs to treat as a component boundary.
export const MT_DOWNLOAD_OPTION_LABELS: Partial<
  Record<SessionDownloadOption, string>
> = {
  events_json: 'Events (.json)',
  events_csv: 'Events (.csv)',
  pitch_anchor_json: 'Pitch & anchor data (.json)',
  session_players_json: 'Session Players (.json)',
  session_metadata_csv: 'Session Metadata (.csv)',
  physical_metrics_csv: 'Physical Metrics (.csv)',
  position_packets_parquet: 'Position Packets (.parquet)',
  sportscode_xml: 'Sportscode (.xml)'
}

// Preserves Match Tracker's existing checkbox order: unit-scoped types in
// their natural SESSION_DOWNLOAD_OPTIONS order, then the "always original
// recorded units" types reordered so packets sorts after pitch anchor /
// session players rather than before them. A future MT type not listed here
// still renders, just after these preferred types rather than being
// silently dropped (see sortByDisplayPreference).
const MT_DISPLAY_PREFERENCE: SessionDownloadOption[] = [
  'events_json',
  'events_csv',
  'sportscode_xml',
  'session_metadata_csv',
  'physical_metrics_csv',
  'pitch_anchor_json',
  'session_players_json',
  'position_packets_parquet'
]

// Match Tracker's own option list, passed explicitly to DownloadForm at its
// call site (SessionCard/hooks.tsx) since the component takes options as a
// prop instead of assuming them.
export const MT_DOWNLOAD_OPTIONS: SessionDownloadOption[] =
  sortByDisplayPreference(
    SESSION_DOWNLOAD_OPTIONS.filter((option) =>
      SESSION_DOWNLOAD_DEFINITIONS[option].apps.includes('mt')
    ),
    MT_DISPLAY_PREFERENCE
  )
